/** 重新排序 */
export const reorder = <T>(list: T[], startIndex, endIndex): T[] => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

/** 容器间进行拖拽 */
export const move = <T>(sourceData: T[], destinationData: T[], result: any) => {
  const { source, destination } = result || {};
  const sourceClone = Array.from(sourceData);
  const destClone = Array.from(destinationData);
  const [removed] = sourceClone.splice(source.index, 1);

  destClone.splice(destination.index, 0, removed);

  const res = {};
  res[source.droppableId] = sourceClone;
  res[destination.droppableId] = destClone;

  return res;
};
